import { useQuery } from '@tanstack/react-query';
import {
  dashboardApi,
  AdminDashboardStats,
  TeacherDashboardStats,
} from '../../services/api/dashboard';

export const useAdminDashboardStats = (enabled = true) => {
  return useQuery<AdminDashboardStats>({
    queryKey: ['dashboard', 'admin-stats'],
    queryFn: () => dashboardApi.getAdminStats(),
    enabled,
    staleTime: 2 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useTeacherDashboardStats = (enabled = true) => {
  return useQuery<TeacherDashboardStats>({
    queryKey: ['dashboard', 'teacher-stats'],
    queryFn: () => dashboardApi.getTeacherStats(),
    enabled,
    staleTime: 2 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};
